import { Dispatch, Fragment, SetStateAction } from 'react';

import { useEffectOnce } from '@zola/zola-ui/src/hooks';

import useInquiryResolutionsModal from '~/components/common/modals/InquiryResolutionsModal/hooks/useInquiryResolutionsModal';
import { useUserContext } from '~/contexts/UserContext';
import { useOnboardedViaFavoritedStorefront } from '~/hooks/useOnboardedViaFavoritedStorefront';
import useWeddingLocation from '~/hooks/useWeddingLocation';
import useWeddingPreferences from '~/hooks/useWeddingPreferences';
import experimentFlags, { LOGROCKET_MARKETPLACE_LP } from '~/util/experimentFlags';
import { initLogRocket } from '~/util/logrocketUtils';
import { TrackingProductLocation } from '~/util/trackingHelper';

import { PersonalizedContent } from './components/PersonalizedLandingPage/PersonalizedContent';
import VendorStarterPack from './components/VendorStarterPack/VendorStarterPack';
import { getBriefLocation } from './util/helpers';

import styles from './personalizedLandingPage.module.less';

type PersonalizedLandingPageProps = {
  setHasPersonalizedContentLoaded: Dispatch<SetStateAction<boolean>>;
};

const PersonalizedLandingPage = ({
  setHasPersonalizedContentLoaded,
}: PersonalizedLandingPageProps) => {
  useInquiryResolutionsModal();
  const {
    isGuest,
    loaded: weddingPreferencesLoaded,
    hasMarketplaceAccount,
  } = useWeddingPreferences();
  const userContext = useUserContext();
  const { weddingLocation, loaded: weddingLocationLoaded } = useWeddingLocation();
  const briefLocation = getBriefLocation(weddingLocation);

  useEffectOnce(() => {
    if (experimentFlags.isUnderTest(LOGROCKET_MARKETPLACE_LP, userContext)) {
      initLogRocket(true, 'MARKETPLACE_LP');
    }
  });

  useOnboardedViaFavoritedStorefront({
    showCustomInitialToasts: false,
    location: TrackingProductLocation.EXPLORE_VENDORS_PLP,
  });

  if (!weddingPreferencesLoaded && !weddingLocationLoaded) {
    return null;
  }

  return (
    <Fragment>
      {hasMarketplaceAccount && (
        <PersonalizedContent
          briefLocation={briefLocation}
          setHasPersonalizedContentLoaded={setHasPersonalizedContentLoaded}
        />
      )}
      <section className={styles.withBorder}>
        <VendorStarterPack
          vendorMarketId={briefLocation.vendorMarket.id}
          weddingLocation={briefLocation}
          userDataLoaded={isGuest || weddingPreferencesLoaded}
        />
      </section>
    </Fragment>
  );
};

export default PersonalizedLandingPage;
